import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'redux/store';
import App from 'App';
import { checkUserSession } from 'redux/user/user.actions';
import * as serviceWorker from 'serviceWorker';
import './i18n';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';
import { anonimousUser } from 'utils/api.config';
// const renderApp = preloadedState => {
// const store = configureStore(preloadedState);
document.title = window.platform_info.title;

const url = new URL(window.location.href);

// Retrieve the 'token' parameter
const token = url.searchParams.get('token');
// Retrieve the 'hash' parameter
const hash = url.searchParams.get('hash');
const jwtParam = token || hash; // whichever exists
// --- Clean up broken tokens before React mounts ---
const title = window.platform_info.title;
const accessKey = `access_token_r_${title}`;
const refreshKey = `refresh_token_r_${title}`;
const otpLoginKey = `otp_login_bd_${title}`;
const emailLoginKey = `email_based_login_${title}`;

const accessVal = localStorage.getItem(accessKey);
const refreshVal = localStorage.getItem(refreshKey);

function isInvalidToken(value) {
  // If the key doesn't exist (value === null), treat it as valid → return false
  if (value === null) return false;

  return (
    !value ||
    value === 'undefined' ||
    value === 'null' ||
    value === '"undefined"' ||
    value === '"null"'
  );
}

function decodeJWT(token) {
  try {
    if (!token || typeof token !== 'string' || token.split('.').length < 2) {
      throw new Error('Invalid token format');
    }
    const [header, payload, signature] = token.split('.');
    const decodeBase64Url = (str) => {
      let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
      return decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
    };
    return {
      header: JSON.parse(decodeBase64Url(header)),
      payload: JSON.parse(decodeBase64Url(payload)),
      signature
    };
  } catch (err) {
    console.error('JWT decoding failed:', err);
    return null;
  }
}

// Example usage
if (jwtParam) {
  const decoded = decodeJWT(jwtParam);
  const partner = decoded?.payload?.partner;
  if (partner === 'GP_MYGP' || partner === 'ASTHA' || partner === 'BANGLALINK_MYBL') {
    console.log('Clearing localStorage for partner:', partner);
    // setTimeout(() => localStorage.clear(), 0);
    localStorage.clear();
  }
} else {
  console.warn('No token or hash parameter found in URL.');
  // if (isInvalidToken(accessVal) || isInvalidToken(refreshVal)) {
  //   console.warn('Corrupted auth tokens detected — resetting to anonymous mode');
  //   localStorage.removeItem(accessKey);
  //   localStorage.removeItem(refreshKey);
  //   localStorage.removeItem(otpLoginKey);
  //   localStorage.removeItem(emailLoginKey);

  //   // optionally fetch a new temporary token
  //   try {
  //     anonimousUser();
  //   } catch (err) {
  //     console.error('Failed to re-initialize anonymous session:', err);
  //   }
  // }
}

// global error catchers (for logging WSOD)
window.addEventListener('error', (e) => console.error('Global error:', e.error));
window.addEventListener('unhandledrejection', (e) =>
  console.error('Unhandled rejection:', e.reason)
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Suspense fallback="">
        <MixpanelProvider mixpanel={mixpanel}>
          <App />
        </MixpanelProvider>
      </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
try {
  store.dispatch(checkUserSession());
} catch (err) {
  console.error('checkUserSession failed:', err);
}
// };
// (async () => renderApp(await store.dispatch(checkUserSession())))();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
